<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
      <div class="feature-decor">
        <div class="feature-circle1"><img class="circle-2" :src='"../assets/images/circle-2.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="feature-phone">
             <Tile image='feature-mobile.jpg'/>
            <!-- <img :src='"../assets/images/222.png"' class="img-fluid" alt=""> -->
          </div>
          <div class="offset-lg-3 col-lg-9">
            <div class="row">
              <div class="col-sm-12 mrgn-md-top px-lg-0">
                <h1 class="f-400 mb-lg-5 mb-2 mx-2">{{ $t('services.title') }}<span class="green ml-3 f-600">WESERVE GO</span></h1>
              </div>
              <div>
                <ul class="feature-style row ">
                  <li v-for="(step, i) in steps" :key="i" class="col-lg-6 m-lg-0 mb-lg-5 my-3 mx-4">
                    <div class="d-flex align-items-center">
                      <img class="icon" :src='getImage(i + 1)' alt="icon">
                      <div class="feature-subtitle">
                        <h3>{{ $t(step.title) }}</h3>
                      </div>
                    </div>
                    <div>
                      <p class="lh-1">{{ $t(step.description) }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'feature',
  data() {
    return {
      steps: [
        {
          title: 'services.subtitle1',
          description: 'services.content1'
        },
        {
          title: 'services.subtitle2',
          description: 'services.content2'
        },        
        {
          title: 'services.subtitle3',
          description: 'services.content3'
        },       
        {
          title: 'services.subtitle4',
          description: 'services.content4'
        },        
        {
          title: 'services.subtitle5',
          description: 'services.content5'
        },        
        {
          title: 'services.subtitle6',
          description: 'services.content6'
        },
      ]
    }
  },
  methods: {
    getImage(num) {
      return require('../assets/images/icon/' + num + '.png')
    }
  },
}
</script>

<style lang="sass">
  .icon
    max-width: 35px

  .lh-1
    line-height: 1.25
</style>



// WEBPACK FOOTER //
// src/components/feature.vue